import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Delete this as part of berry-4386-add-helpcenterid-to-routes FG clean up
export const helpCenterSettingsCustomerAccessOldRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-customer-access-old',
	path: '/jira/helpcenter/projects/:projectKey/settings/customer-access',
};
